import { httpClient } from "@/lib/http-client";
import { SocialProofAssets, Testimonial } from "@/types";

export const getTestimonial = (id: string) => {
  return httpClient.get<Testimonial>(`/testimonials/${id}`);
};

export const getProjectTestimonials = (id: string) => {
  return httpClient.get<Testimonial[]>(
    `/testimonials/?projectId=${id}&published=true`,
  );
};

export async function getSocialProofAssetsById<P, V>({
  id,
  refId,
}: {
  id?: string;
  refId?: string;
}) {
  const params = new URLSearchParams();

  if (id) params.append("id", id);
  if (refId) params.append("refId", refId);

  return await httpClient.get<SocialProofAssets<P, V>>(
    `/social-proof?${params.toString()}`,
  );
}
